export enum JourneyNodeType {
  // No-Op node type. Meant only for testing.
  NoOp = "no-op",

  EntryEvent = "entry-event",
  EntryCohort = "entry-cohort",
  EntryAudienceExperiment = "entry-audience-experiment",
  WaitUntilEvent = "wait-until-event",
  TimeDelay = "time-delay",
  Segments = "segments",
  Splits = "splits",
  Sync = "sync",
  Context = "context",
  CouponAssignment = "coupon-assignment",
  Message = "message",

  // Branch nodes
  SegmentBranch = "segment-branch",
  WaitUntilEventBranch = "wait-until-event-branch",
  SplitBranch = "split-branch",
  EntryAudienceExperimentBranch = "entry-audience-experiment-branch",
}

export enum JourneyNodeSyncMode {
  Cohort = "cohort",
  Trigger = "trigger",
}
